<template lang="pug" src="./resources/schedule.pug"></template>

<script>

import _ from 'lodash'
import Color from 'color'

import { mapGetters, mapMutations } from 'vuex'

import TeaserList from './TeaserList'
import FormModal from './FormModal'
import Loading from 'vue-loading-overlay'

import { areIntervalsOverlapping, startOfDay, endOfDay, startOfWeek, endOfWeek, isSameDay, parse, format, add } from 'date-fns'
import { date2timestamp, timestamp2date, formatDate } from '@/filters';

export default {
    name: 'WeekSchedule',
    extends: TeaserList,
    props: {
        startTime: {
            type: Number,
            default: parseInt(format(parse('08:00', 'HH:mm', new Date(0)), 't')), // 10 Uhr
        },
        endTime: {
            type: Number,
            default: parseInt(format(parse('22:00', 'HH:mm', new Date(0)), 't')), // 22 Uhr
        },
        current: {
            type: Date,
            default: () => new Date
        },
    },
    data() {
        return {
            fetching: false,
            timer: undefined,
            focused: undefined,
            focusTimeout: undefined,
            matrix: {
                time: new Date,
                // period: 7, // days
                steps: {
                    major: 60 * 60, // 1 Stunde
                    minor: 15 * 60, // 15 Minuten
                },
            },
            modal: {
                visible: false,
                slot: undefined,
            }
        }
    },
    components: {
        Loading,
        FormModal,
    },
    watch: {
        current(value) {
            this.load()
        }
    },
    computed: {
        minorStepHeight() {
            let majorStepHeight = 64
            let steps = this.matrix.steps.major / this.matrix.steps.minor
            return majorStepHeight / steps
        },
        slots() {
            // return _.get(this.event, 'slots') || []

            let slots = []
            const teasers = this.teasers || []
            teasers.forEach(slot => {
                slot = _.cloneDeep(slot)

                // fix times - timezone issue

                const start_time = parseInt(format(parse(
                    `${formatDate(timestamp2date(slot.start_at), 'HH:mm')}`,
                    'HH:mm',
                    new Date(0)
                ), 't'))

                slot.start_time = start_time

                const end_time = parseInt(format(parse(
                    `${formatDate(timestamp2date(slot.end_at), 'HH:mm')}`,
                    'HH:mm',
                    new Date(0)
                ), 't'))

                slot.end_time = end_time

                slots.push(slot)
            })

            return slots
        },
        // slot: {
        //     get() {
        //         if (this.selections[this.$route.path] && this.selections[this.$route.path].slot)
        //             return this.selections[this.$route.path].slot
        //     },
        //     set(slot) {
        //         this.selectSlot({ key: this.$route.path, slot })
        //     }
        // },
        firstDayTimestamp() {
            let firstDayTimestamp = parseInt(format(startOfDay(this.current), 't'))
            if (this.period === 7) {
                firstDayTimestamp = parseInt(format(startOfWeek(this.current, { weekStartsOn: 1 }), 't'))
            }
            return firstDayTimestamp
        },
        steps() {
            let steps = []

            let i = this.startTime
            while (i < this.endTime) {
                if (i % this.matrix.steps.major === 0) steps.push({ type: 'major', time: timestamp2date(i) })
                else if (i % this.matrix.steps.minor === 0) steps.push({ type: 'minor', time: timestamp2date(i) })

                ++ i
            }

            return steps
        },
        days() {
            let days = []

            let i = 0
            while(i < 7) {
                // this.period

                // add day counter to first date to get the relevant timestamp
                // const start = this.firstDayTimestamp + (24 * 60 * 60 * i)
                const start = parseInt(format(add(startOfWeek(this.current, { weekStartsOn: 1 }), { days: i }), 't'))
                const end = parseInt(format(endOfDay(timestamp2date(start)), 't'))

                let slots = []
                this.slots.filter(slot => slot.end_at >= start && slot.start_at <= end).forEach(el => {
                    let slot = _.cloneDeep(el)

                    slot.starts_today = isSameDay(timestamp2date(el.start_at), timestamp2date(start))
                    slot.ends_today = isSameDay(timestamp2date(el.end_at), timestamp2date(end))

                    // positioning based on the
                    // number of overlapping elements, etc
                    // getting calculated in the following loops
                    slot.grid = {
                        columns: 1,
                        position: { start: 1, end: 2 }
                    }

                    slot.show_info = false
                    if (slot.starts_today || i === 0) {
                        slot.show_info = true
                    }


                    // check if the slot starts after it ends
                    // or ends before the schedule start time
                    // starts after the schedule end time
                    // =====
                    // skip slot if true

                    if (slot.start_at >= slot.end_at) return true
                    if (slot.starts_today && slot.start_time >= this.endTime) return true
                    if (slot.ends_today && slot.end_time <= this.startTime) return true

                    slots.push(slot)
                })

                slots = slots.sort((a, b) => a.start_at - b.start_at)

                // check for overlapping slots
                if (slots.length > 1) {
                    for (let s = 0; s < slots.length; s++) {
                        const debug = s === 5;

                        // group overlapping items
                        // determine start / end position of the current slot
                        // and the total number of columns for this group
                        // ++++++++++++++++++++++++++++++++++++++++++++++++++
                        // 1. run through all slots untill not more overlapping and create a group
                        // 2. get occupied space from all slots before the current one
                        // 3. find an empty space by checking the occupied
                        //    and determine the position of the current slot by that
                        // 4. get number of columns by the largest position.start value
                        // 5. update the columns values of all grouped slots

                        let slot = slots[s];

                        let columns = 1;
                        let start, end, group;
                        let occupied = [];

                        let finalOverlapping = 2;

                        // go through all slots and group overlapping ones
                        // also get the occupied space
                        for (let a = 0; a < slots.length; a++) {
                            if (a === s) continue;
                            const overlapping = areIntervalsOverlapping(
                                {
                                    start: fromUnixTime(slot.start_at),
                                    end: fromUnixTime(slot.end_at),
                                },
                                {
                                    start: fromUnixTime(slots[a].start_at),
                                    end: fromUnixTime(slots[a].end_at),
                                }
                            );

                            if (overlapping) {
                                if (!group) group = slots[a].group || uniqid(`${s}:`);
                                slots[a].group = group;
                                columns = Math.max(columns, slots[a].grid.columns);

                                finalOverlapping = Math.max(
                                    finalOverlapping,
                                    slots[a].grid.position.end
                                );

                                // get occupied space of previous slots
                                if (a < s) {
                                    occupied.push({
                                        slot: slots[a],
                                        start: slots[a].grid.position.start,
                                        end: slots[a].grid.position.end,
                                    });
                                }
                            }
                        }

                        if (group) {
                            slot.group = group;

                            // find an empty space by checking the occupied array
                            if (occupied.length) {
                                let c = 1;
                                while (c < finalOverlapping) {
                                    const match = occupied.find(
                                        (el) => el.start <= c && el.end >= c + 1
                                    );

                                    if (!match && start === undefined) {
                                        // found an empty space
                                        start = c;
                                    } else if (match && match.start > start) {
                                        // check if this occupied space
                                        // limits the positioning of the current slot
                                        end = match.start;
                                        break;
                                    }
                                    c++;
                                }

                                if (debug) console.log(occupied);
                                if (debug) console.log(start);

                                if (start === undefined) {
                                    // there is no empty space left inbetween overlapping ones
                                    // check if there are expanded slots
                                    // if not add the current slot to the end

                                    const largeSlots = occupied.filter(
                                        (el) => el.end - el.start > 1
                                    );

                                    if (
                                        largeSlots &&
                                        largeSlots.length &&
                                        finalOverlapping >= columns + 1
                                    ) {
                                        // reduce width of the first (or better the largest) slot from largeSlots
                                        // and change the position of all following slots in the occupied array
                                        // so that there is space left for the current slot
                                        const match = largeSlots[0];
                                        occupied.forEach((el) => {
                                            if (
                                                el.slot.grid.position.start >=
                                                match.slot.grid.position.end
                                            ) {
                                                el.slot.grid.position.start--;
                                                el.slot.grid.position.end--;

                                                start = Math.max(start || 1, el.slot.grid.position.end);
                                            }
                                        });
                                        match.slot.grid.position.end--;
                                    } else {
                                        start = finalOverlapping;
                                        // end = start + 1;
                                    }
                                }
                            }

                            if (start !== undefined) slot.grid.position.start = start;
                            if (end !== undefined) slot.grid.position.end = end;

                            // get number of columns by the largest position.start value
                            for (let a = 0; a < slots.length; a++) {
                                if (slots[a].group !== group) continue;
                                columns = Math.max(columns, slots[a].grid.position.start);
                            }

                            // update the columns values of all grouped slots
                            for (let a = 0; a < slots.length; a++) {
                                if (slots[a].group !== group) continue;
                                slots[a].grid.columns = columns;
                            }

                            // if not end position has been found
                            // set it to the largest possible value
                            if (end === undefined && start !== undefined) {
                                slot.grid.position.end = Math.max(start + 1, columns + 1);
                            }
                        }
                    }
                }

                let day = { slots }

                i ++

                days.push({
                    nr: i,
                    date: timestamp2date(start),
                    slots
                })
            }

            return days
        },
        currentTimePosition() {
            const span = this.endTime - this.startTime

            // get timestamp from time of current day only
            let timestamp = parseInt(format(parse(`${format(this.matrix.time, 'HH:mm:ss')}`, 'HH:mm:ss', new Date(0)), 't'))
            timestamp -= this.startTime

            const position = timestamp / span * 100
            // return Math.min(100, Math.max(0, position))
            if (position <= 100 && position >= 0) return position
            return undefined
        },
        ...mapGetters({
            period: 'event/preferredWeekPeriod',
        })
    },
    // filters: {
    //     format(date, pattern = 'dd.MM.yyyy') {
    //         if (_.isInteger(date)) date = timestamp2date(date)
    //         return formatDate(date, pattern)
    //     }
    // },
    methods: {
        getStepStyle(i) {
            const top = `${i / this.steps.length * 100}%`
            const height = `${100 / this.steps.length}%`

            return {
                position: 'absolute',
                height,
                top,
            }
        },
        getDotStyle(slot) {
            let style = {}

            let hex = slot.event.color || slot.event.category.color
            if (hex) {
                let color = Color(hex)
                const lightness = color.lightness()
                if (lightness > 70) color = color.lightness(70)
                style['background-color'] = color.rgb().string();
            }

            return style
        },
        getSlotStyle(d, s) {
            const padding = 4;

            const day = this.days[d];
            const slot = day.slots[s];

            const span = this.endTime - this.startTime;

            let start = slot.start_time - this.startTime;
            let end = slot.end_time - this.startTime;

            if (!slot.starts_today) start = -1;
            if (!slot.ends_today) end = this.endTime;

            const duration = end - start;

            const topPercentage = (start / span) * 100;
            let heightPercentage = (duration / span) * 100;

            let height = `calc(${heightPercentage}% - ${padding}px)`;
            let top = `calc(${topPercentage}% + ${padding / 2}px)`;
            let left = `${padding}px`;
            // let right = `${padding}px`
            let width = `calc(100% - ${2 * padding}px)`;

            // check for overlapping slots
            if (slot.grid.columns > 1) {
                const percentage =
                    (100 / slot.grid.columns) *
                    (slot.grid.position.end - slot.grid.position.start);

                width = `calc(${percentage}% - (${padding}px + ${(padding / 100) * percentage}px))`;

                const columnPercentage = 100 / slot.grid.columns;
                const startPercentage =
                    columnPercentage * (slot.grid.position.start - 1);

                left = `calc(${startPercentage}% + ${padding}px - ${(padding / 100) * columnPercentage * (slot.grid.position.start - 1)}px)`;
            }

            // starts on same day but before the given timespan
            if (topPercentage < 0) {
                top = `calc(0% - ${2 * padding}px)`;
                heightPercentage += topPercentage;
                height = `calc(${heightPercentage}% + ${padding}px)`;
            }

            // ends on same day but later the given timespan
            if (heightPercentage > 100) {
                let dif = heightPercentage - 100;
                heightPercentage -= dif;
                height = `calc(${heightPercentage}% + ${4 * padding}px)`;
            } else if (heightPercentage + topPercentage > 100) {
                let dif = heightPercentage + topPercentage - 100;
                heightPercentage -= dif;
                height = `calc(${heightPercentage}% + ${padding}px)`;
                if (topPercentage <= 0)
                    height = `calc(${heightPercentage}% + ${4 * padding}px)`;
            }

            let style = {
                position: "absolute",
                height,
                top,
                left,
                // right,
                width,
            };

            return style;
        },
        getSlotClass(d, s) {
            let cls = []

            const day = this.days[d]
            const slot = day.slots[s]

            // if (this.slot && this.slot.id === slot.id) cls.push('selected')

            // const limit = slot.member_limit || this.event.member_limit_per_slot
            // if (limit > 0 && slot.bookings.length >= limit) cls.push('disabled')

            if (! slot.starts_today || ! slot.ends_today) cls.push('large-date')
            if (this.focused === slot.id) cls.push('focused')

            return cls
        },
        isFullHour(time) {
            return time % (60 * 60) === 0
        },
        isCurrentDay(date) {
            return isSameDay(date, new Date)
        },
        isVisible(day) {
            let visible = true
            if (this.period === 1) {
                visible = isSameDay(this.current, day.date)
            } else if (this.period < 7) {
                // TODO: handle others by checking for overlapping
            }
            return visible
        },
        load(page = 1, force = false) {
            let pagination = _.get(this.section, 'teasers.pagination')

            // default timespan setting is 'auto'
            let key, timestampFilter;
            if (this.timespan === 'future') key = 'from';
            else if (this.timespan === 'past') key = 'to';
            if (key) {
                timestampFilter = { key }
                timestampFilter[key] = format(new Date, 't')
            }

            const inclusiveFilter = {
                key: 'inclusive_timespan',
                from: format(startOfWeek(this.current, { weekStartsOn: 1 }), 't'),
                to: format(endOfWeek(this.current, { weekStartsOn: 1 }), 't'),
            }

            if (! pagination) {
                const categories = this.section.eventCategories.map(category => category.id)
                pagination = {
                    filters: [
                        inclusiveFilter,
                        { key: 'categories', in: categories },
                        { key: 'cms', match: this.cms.id }
                    ],
                    pageInfo: {
                        currentPage: 1,
                        lastPage: 1,
                        total: 0,
                        perPage: 500
                    },
                }
            } else {
                const i = _.findIndex(pagination.filters, { key: 'inclusive_timespan' });

                if (i >= 0) {
                    // skip refetching if the inclusive_timespan did not change
                    if (force === false
                        && pagination.filters[i].from === inclusiveFilter.from
                        && pagination.filters[i].to === inclusiveFilter.to) return

                    pagination.filters[i] = inclusiveFilter
                } else {
                    pagination.filters.push(inclusiveFilter)
                }

                // remove filters related to list display type
                const x = _.findIndex(pagination.filters, { key: 'from' });
                if (x >= 0) pagination.filters.splice(x, 1);
                const y = _.findIndex(pagination.filters, { key: 'to' });
                if (y >= 0) pagination.filters.splice(y, 1);
                // pagination.pageInfo.currentPage = page
            }

            if (timestampFilter) {
                pagination.filters.push(timestampFilter);
            }

            this.fetching = true;

            this.fetchTeasers(pagination)
                .then(({ items, pageInfo }) => {
                    let filters = _.cloneDeep(pagination.filters);
                    const teasers = {
                        loading: false,
                        pagination: { filters, items, pageInfo }
                    };
                    this.insertTeasers({ s: this.s, teasers });
                })
                .finally(() => (this.fetching = false));
        },
        updateCurrentDay(day) {
            this.$emit('update', day.date)
        },
        hover(el) {
            if (this.focusTimeout) clearTimeout(this.focusTimeout)
            this.focused = el.id
        },
        blur() {
            this.focusTimeout = setTimeout(() => {
                this.focused = undefined
            }, 150);
        },
        showModal(slot) {
            this.modal.slot = slot
            this.modal.visible = true
        },
        hideModal() {
            this.modal.visible = false
            this.modal.slot = undefined
        },
        ...mapMutations({
            setPeriod: 'event/setPreferredWeekPeriod'
        })
    },
    mounted() {
        this.load()
        this.timer = setInterval(() => {
            this.matrix.time = new Date
        }, 1000);

        const calculateMaxWidth = () => {
            if (this.$refs.container) {
                const style = getComputedStyle(this.$refs.container)
                let width = this.$refs.container.clientWidth
                width -= parseFloat(style.paddingLeft) + parseFloat(style.paddingRight)

                if (width < 1080) {
                    this.setPeriod(1)
                } else {
                    this.setPeriod(7)
                }
            }
        }

        window.addEventListener('resize', calculateMaxWidth)
        // window.addEventListener('resize', _.debounce(calculateMaxWidth, 100))
        calculateMaxWidth()
    },
    beforeDestroy() {
        if (this.modal.visible) {
            this.hideModal()
        }
    },
    destroyed() {
        clearInterval(this.timer)
    }
}

</script>

<style lang="sass" scoped>
    @import "./resources/schedule"
</style>
